export default __webpack_public_path__ + "static/media/inventory-filters-icon.99dd2569.svg";